import { api } from "./client";

const BASE = "/games/mlb";

export async function getActiveSeason() {
  const resp = await api.get(`${BASE}/seasons/active`);
  return resp.data;
}

export async function getMyMlbPools(seasonId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/mine`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function getAllMlbPools(seasonId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function createMlbPool(seasonId, { name, pool_depth }) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/`, { name, pool_depth });
  return resp.data;
}

export async function joinMlbPool(seasonId, poolId) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/join`);
  return resp.data;
}

export async function getMlbPool(seasonId, poolId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}`);
  return resp.data;
}

export async function getMlbLeaderboard(seasonId, poolId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}/leaderboard/`);
  return resp.data;
}

export async function getMyMlbRosters(seasonId, poolId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}/roster/mine`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function getMlbRoster(seasonId, poolId, rosterId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}/roster/${rosterId}`);
  return resp.data;
}

export async function createMlbRoster(seasonId, poolId, { team_name, player_ids }) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/roster/`, {
    team_name,
    player_ids,
  });
  return resp.data;
}

export async function renameMlbRoster(seasonId, poolId, rosterId, teamName) {
  const resp = await api.patch(`${BASE}/seasons/${seasonId}/pools/${poolId}/roster/${rosterId}`, { team_name: teamName });
  return resp.data;
}

export async function updateMlbRoster(seasonId, poolId, rosterId, { team_name, player_ids }) {
  const resp = await api.put(`${BASE}/seasons/${seasonId}/pools/${poolId}/roster/${rosterId}`, { team_name, player_ids });
  return resp.data;
}

export async function deleteMlbRoster(seasonId, poolId, rosterId) {
  await api.delete(`${BASE}/seasons/${seasonId}/pools/${poolId}/roster/${rosterId}`);
}

export async function validateMlbSwap(seasonId, poolId, { roster_id, remove_player_id, add_player_id }) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/roster/swap/validate`, {
    roster_id,
    remove_player_id,
    add_player_id,
  });
  return resp.data;
}

export async function applyMlbSwap(seasonId, poolId, { roster_id, remove_player_id, add_player_id }) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/roster/swap`, {
    roster_id,
    remove_player_id,
    add_player_id,
  });
  return resp.data;
}

export async function updateMlbPool(seasonId, poolId, body) {
  const resp = await api.patch(`${BASE}/seasons/${seasonId}/pools/${poolId}`, body);
  return resp.data;
}

export async function toggleMlbMemberPaid(seasonId, poolId, userId, paid) {
  const resp = await api.patch(`${BASE}/seasons/${seasonId}/pools/${poolId}/members/${userId}/paid`, { paid });
  return resp.data;
}

export async function toggleMlbCoAdmin(seasonId, poolId, userId, isCoAdmin) {
  const resp = await api.patch(`${BASE}/seasons/${seasonId}/pools/${poolId}/members/${userId}/co-admin`, { is_co_admin: isCoAdmin });
  return resp.data;
}

export async function removeMlbMember(seasonId, poolId, userId) {
  const resp = await api.delete(`${BASE}/seasons/${seasonId}/pools/${poolId}/members/${userId}`);
  return resp.data;
}

export async function getMlbPayouts(seasonId, poolId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}/payouts/`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function saveMlbPayouts(seasonId, poolId, payouts) {
  const resp = await api.put(`${BASE}/seasons/${seasonId}/pools/${poolId}/payouts/`, { payouts });
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function sendMlbInvites(seasonId, poolId, emails, message, subject, mode) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/invite`, { emails, message, subject, mode }, { timeout: 120000 });
  return resp.data;
}

export async function sendMlbRecapTest(seasonId, poolId) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/recap-test`, null, { timeout: 30000 });
  return resp.data;
}

export async function getMlbPlayers(seasonId, { search, min_prev_hrs } = {}) {
  const params = {};
  if (search) params.search = search;
  if (min_prev_hrs != null) params.min_prev_hrs = min_prev_hrs;
  const resp = await api.get(`${BASE}/seasons/${seasonId}/players/`, { params });
  return Array.isArray(resp.data) ? resp.data : [];
}

// ── Smack Board ───────────────────────────────────────────────────────────────

export async function getMlbSmackMessages(poolId, seasonId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}/smack/`);
  return resp.data;
}

export async function postMlbSmackMessage(poolId, body, seasonId) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/smack/`, { body });
  return resp.data;
}

export async function getMlbSmackReplies(poolId, messageId, seasonId) {
  const resp = await api.get(`${BASE}/seasons/${seasonId}/pools/${poolId}/smack/${messageId}/replies`);
  return resp.data;
}

export async function postMlbSmackReply(poolId, messageId, body, seasonId) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/smack/${messageId}/replies`, { body });
  return resp.data;
}

export async function reactMlbSmack(poolId, messageId, reaction, seasonId) {
  const resp = await api.post(`${BASE}/seasons/${seasonId}/pools/${poolId}/smack/${messageId}/react`, { reaction });
  return resp.data;
}

export async function deleteMlbSmackMessage(poolId, messageId, seasonId) {
  const resp = await api.delete(`${BASE}/seasons/${seasonId}/pools/${poolId}/smack/${messageId}`);
  return resp.data;
}
